const mediaItems = [
  {
    title: '热血完结漫 · 高燃名场面混剪',
    desc: '那些让人热血沸腾的完结漫画经典战斗场景回顾，每一帧都是青春的回忆。',
    duration: '04:32',
    views: '12.8万',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20scene%20inspired%20by%20Japanese%20manga%2C%20warm%20orange%20and%20red%20energy%20effects%2C%20dramatic%20lighting%2C%20cinematic%20wide%20composition%2C%20illustration%20style%2C%20no%20text%2C%20epic%20atmosphere&width=640&height=360&seq=media-manga-01&orientation=landscape',
  },
  {
    title: '恋爱甜漫完结 · 最甜告白合集',
    desc: '从初遇到告白的名场面回顾，恋爱类完结漫画中最让人心动的甜蜜瞬间。',
    duration: '05:18',
    views: '9.6万',
    img: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20manga%20style%20illustration%2C%20cherry%20blossoms%20floating%20in%20warm%20spring%20light%2C%20gentle%20pink%20and%20peach%20tones%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20beautiful%20composition&width=640&height=360&seq=media-manga-02&orientation=landscape',
  },
  {
    title: '异世界完结漫 · 穿越之旅全记录',
    desc: '从平凡日常到异世界冒险，完结漫画中那些让人印象深刻的穿越名场面。',
    duration: '06:45',
    views: '8.3万',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20world%20illustration%20with%20glowing%20magical%20portal%2C%20warm%20golden%20sunset%20light%2C%20ancient%20castle%20silhouette%2C%20adventure%20atmosphere%2C%20illustration%20style%2C%20no%20text%2C%20epic%20composition&width=640&height=360&seq=media-manga-03&orientation=landscape',
  },
  {
    title: '悬疑完结漫 · 最震撼结局盘点',
    desc: '那些结局让人倒吸一口凉气的悬疑推理完结漫画，反转再反转的震撼瞬间。',
    duration: '07:21',
    views: '11.2万',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20style%20illustration%2C%20dramatic%20warm%20amber%20lighting%2C%20shadows%20and%20silhouettes%2C%20suspenseful%20atmosphere%2C%20cinematic%20composition%2C%20no%20text%2C%20moody%20aesthetic&width=640&height=360&seq=media-manga-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            视频专区
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            完结漫画名场面回顾与精彩内容盘点
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center transition-transform duration-200 group-hover:scale-110">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}